import React from 'react';
import DownArrowIcon from '../commons/icons/down_arrow';
import CVForm from './CVForm';
import { AccordionContainer, SubTitle } from './EditCV.styled';

const CVAccordion = ({
  values,
  index,
  errors,
  handleChange,
  setErrors,
  setValues,
  currentOpenedAccordionItemIndex,
  setCurrentOpenedAccordionItemIndex,
  departmentList,
  isCurrentHotel,
  allHotelData,
}) => {
  const identifier = `${isCurrentHotel ? 'currentHotel' : 'previousHotel'}-${values[0].hotelName}-${index}`;
  return (
    <>
      <AccordionContainer
        onClick={() => {
          if (currentOpenedAccordionItemIndex === identifier) {
            setCurrentOpenedAccordionItemIndex(-1);
          } else {
            setCurrentOpenedAccordionItemIndex(identifier);
          }
        }}
      >
        <span>{values[0].hotelName}</span> <DownArrowIcon />
      </AccordionContainer>

      {currentOpenedAccordionItemIndex === identifier &&
        values.map((value, index) => {
          return (
            <>
              {index !== 0 && (
                <SubTitle>Other positions held at this hotel: </SubTitle>
              )}
              <div>
                <CVForm
                  values={values}
                  index={index}
                  errors={errors}
                  handleChange={handleChange}
                  setErrors={setErrors}
                  setValues={setValues}
                  showFormTitle={false}
                  departmentList={departmentList}
                  isCurrentHotel={isCurrentHotel}
                  hotelName={values[index].hotelName}
                  allHotelData={allHotelData}
                />
              </div>
            </>
          );
        })}
    </>
  );
};

export default CVAccordion;
